import { Reveal } from "@/components/Reveal";
import { ShieldCheck, Award, BadgeCheck } from "lucide-react";

const CARDS = [
  {
    icon: ShieldCheck,
    badge: "2 años de garantía",
    title: "Garantía de Instalación",
    desc: "Cobertura integral durante 24 meses sobre toda la mano de obra, tuberías de cobre, sellados, interconexión eléctrica, soportes y desagües. Si cualquier elemento de nuestra instalación presenta una incidencia, la corregimos sin coste alguno para usted.",
    testid: "guarantee-card-installation",
  },
  {
    icon: Award,
    badge: "3 años de garantía",
    title: "Garantía de la Máquina",
    desc: "Respaldo oficial del fabricante durante 36 meses, con gestión prioritaria de repuestos originales. Nos ocupamos de todo el trámite para que usted no tenga que preocuparse por nada.",
    testid: "guarantee-card-machine",
  },
  {
    icon: BadgeCheck,
    badge: "5 años de trayectoria",
    title: "Experiencia Comprobada",
    desc: "Cientos de instalaciones exitosas en viviendas y negocios avalan nuestra técnica y seriedad ejecutiva. Desde 2021, cada proyecto nos ha hecho más exigentes con nosotros mismos.",
    testid: "guarantee-card-experience",
  },
];

export const Guarantees = () => (
  <section
    id="garantias"
    data-testid="guarantees-section"
    className="relative overflow-hidden bg-navy py-16 sm:py-24 lg:py-32"
  >
    <div className="grain-overlay pointer-events-none absolute inset-0" />
    <div className="pointer-events-none absolute -top-32 right-0 h-96 w-96 rounded-full bg-ocean-600/20 blur-3xl" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
      <div className="max-w-2xl">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-ocean-500">
            Garantías y Compromisos
          </p>
          <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl text-balance">
            Promesas que firmamos, no que contamos
          </h2>
          <p className="mt-5 text-base leading-relaxed text-slate-300">
            En Clima Oliver cada garantía se entrega documentada por escrito junto a la
            factura de su instalación. Es nuestra forma de demostrar que la calidad no se
            anuncia: se certifica.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {CARDS.map((card, i) => (
          <Reveal key={card.title} delay={i * 0.12}>
            <article
              data-testid={card.testid}
              className="group h-full rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur transition-all duration-300 hover:-translate-y-1.5 hover:border-ocean-500/40 hover:bg-white/[0.08] sm:p-8"
            >
              <span className="inline-flex items-center gap-2 rounded-full bg-ember/15 px-3.5 py-1.5 text-xs font-bold uppercase tracking-widest text-ember-500">
                <card.icon className="h-3.5 w-3.5" />
                {card.badge}
              </span>
              <h3 className="mt-5 font-display text-xl font-bold text-white sm:text-2xl">
                {card.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-300">{card.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
